import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { InsurenetInterfaceService } from '@core';
import { InsuredObject } from '@models/insured-object';
import { InsuredObjectFormConfig } from '@models/insured-object-form-config';

@Component({
    selector: 'app-summary-insured-objects',
    templateUrl: './summary-insured-objects.component.html',
    styleUrls: ['./summary-insured-objects.component.scss'],
    standalone: false,
})
export class SummaryInsuredObjectsComponent implements OnInit {
    @Input()
    public insuredObjects: InsuredObject[];
    @Input()
    public insuredObjectsConfig: InsuredObjectFormConfig;

    public options: { [key: string]: { label: string | number; value: unknown }[] } = {};
    public constructor(private insurenetInterface: InsurenetInterfaceService) {}

    public ngOnInit(): void {
        if (this.insuredObjectsConfig) {
            this.insuredObjectsConfig.controls.forEach((controlConfig) => {
                if (controlConfig.type === 'select') {
                    if (
                        typeof controlConfig.options === 'string' &&
                        typeof this.insurenetInterface[controlConfig.options] === 'function'
                    ) {
                        (
                            this.insurenetInterface[controlConfig.options](
                                ...controlConfig.optionsParams,
                            ) as Observable<{ label: string | number; value: unknown }[]>
                        ).subscribe((options) => {
                            this.options[controlConfig.name] = options;
                        });
                    } else if (typeof controlConfig.options === 'function') {
                        controlConfig.options().subscribe((options) => {
                            this.options[controlConfig.name] = options;
                        });
                    }
                }
            });
        }
    }

    public getOptionDescription(controlName: string, value: unknown): string {
        if (typeof this.options[controlName] !== 'undefined' && Array.isArray(this.options[controlName])) {
            const ctrl = this.options[controlName].find((item) => item.value === value);
            if (ctrl) {
                return ctrl.label + '';
            }
        }
        return 'keine Angabe';
    }
}
